// Auto-refactored from translations.js on 2026-08-19
// Locale: el

const el = {
  wieMoeglich: { question: 'Πώς είναι δυνατόν;', answer: 'Επανασχεδιάσαμε την αλυσίδα αξίας.' },
  stigRockWeg: {
    overline: 'STIG ROCK',
    title: 'Ο δρόμος STIG ROCK',
    fazit: 'Η συντομευμένη εφοδιαστική αλυσίδα εξαλείφει τις μεγαλύτερες θέσεις κόστους.',
    fazitBigPre: 'Αυτό επιτρέπει έκπτωση έως',
    fazitBigValue: '80%',
    steps: [ 'Ορυχείο', 'Εργαστήριο κοπής', 'Πιστοποίηση', 'Τελικός πελάτης' ]
  },
  nav: { language: 'Γλώσσα', contact: 'Επικοινωνία' },
  hero: {
    overline: 'STIG ROCK — Diamond Solution',
    title: 'Μια μοναδική ευκαιρία',
    subtitle: 'Δημιουργία πλούτου με προσανατολισμό στο μέλλον.',
    description: 'Η STIG ROCK είναι μια διεθνής πλατφόρμα που προσφέρει στους ανθρώπους πρόσβαση σε φυσικά διαμάντια, βιώσιμη δημιουργία περιουσίας και μια μοναδική κοινότητα.',
    scroll: 'Κυλήστε για να ανακαλύψετε'
  },
  disclaimer: {
    overline: 'Νομική Σημείωση',
    title: 'Disclaimer',
    paragraphs: [
      'Αυτή η παρουσίαση χρησιμεύει αποκλειστικά για ενημέρωση και δεν αποτελεί χρηματοοικονομική, επενδυτική ή φορολογική συμβουλή.',
      'Το STIG ROCK δεν είναι χρηματοοικονομικό προϊόν, αλλά αναφέρεται σε φυσικά Diamond ως περιουσιακά στοιχεία.',
      'Δεν παρέχεται καμία εγγύηση για την εξέλιξη της αξίας, τα κέρδη ή τις αποδόσεις. Οι παρελθούσες επιδόσεις δεν αποτελούν ένδειξη για μελλοντικά αποτελέσματα.',
      'Όλοι οι υπολογισμοί που παρουσιάζονται σε σχέση με τις προμήθειες είναι αποκλειστικά παραδειγματικοί και επίσης δεν αποτελούν εγγύηση.'
    ]
  },
  aufgebaut: {
    overline: 'STIG GROUP',
    titleLines: [ 'ΔΟΜΗΜΕΝΟ', 'ΣΕ ΣΥΓΚΡΟΤΗΜΕΝΗ ΒΑΣΗ' ],
    body: 'Η STIG GROUP είναι ένας διεθνής όμιλος, δομημένος πάνω στη διαφάνεια, την ευθύνη και τη μακροπρόθεσμη αξία. Κάθε μάρκα, κάθε εγχείρημα και κάθε Partner ακολουθεί ένα ενιαίο πρότυπο — χωρίς συντομεύσεις, χωρίς εξαιρέσεις.',
    stages: [
      {
        brand: 'STIG GROUP',
        titleLines: [ 'ΔΟΜΗΜΕΝΟ', 'ΣΕ ΣΥΓΚΡΟΤΗΜΕΝΗ ΒΑΣΗ' ],
        body: 'Η STIG GROUP είναι ένας διεθνής όμιλος, δομημένος πάνω στη διαφάνεια, την ευθύνη και τη μακροπρόθεσμη αξία. Κάθε μάρκα, κάθε εγχείρημα και κάθε Partner ακολουθεί ένα ενιαίο πρότυπο — χωρίς συντομεύσεις, χωρίς εξαιρέσεις.'
      },
      {
        brand: 'STIG ROCK',
        titleLines: [ 'Ο ΚΟΣΜΟΣ ΤΩΝ', 'ΑΠΟΚΛΕΙΣΤΙΚΩΝ DIAMOND' ],
        body: 'Το STIG ROCK είναι ένα σύγχρονο concept της STIG GROUP, που συνδυάζει υψηλής ποιότητας Diamond με πιστοποίηση GIA με διαφανείς δομές και μια αποκλειστική εμπειρία πελάτη. Σαφή πλάνα λύσεων, επαγγελματική διεκπεραίωση και διεθνή προσανατολισμό.'
      },
      {
        brand: 'Stig International',
        titleLines: [ 'ΔΙΕΘΝΕΣ', 'ΕΜΠΟΡΙΟ DIAMOND' ],
        body: 'Η Stig International αποτελεί μέρος της STIG GROUP και εξειδικεύεται στο διεθνές εμπόριο Diamond με πιστοποίηση GIA. Εστίαση στην ποιότητα, την εμπιστοσύνη και τις σύγχρονες εμπορικές δομές με παγκόσμιες συνεργασίες.'
      },
      {
        brand: 'ETHICAL MINES',
        titleLines: [ 'ΕΥΘΥΝΗ', 'ΑΠΟ ΤΟ ΟΡΥΧΕΙΟ' ],
        body: 'Η Ethical Mines αντιπροσωπεύει την υπεύθυνη εξόρυξη, την ανιχνεύσιμη προέλευση και τα Diamond χωρίς συγκρούσεις. Από το ορυχείο μέχρι την αγορά — πλήρης τεκμηρίωση για διαφάνεια, ακεραιότητα και μακροπρόθεσμη ευθύνη σε όλη την αλυσίδα εφοδιασμού.'
      }
    ]
  },
  moeglichkeiten: {
    stigLine: 'Διαμάντια',
    stigDrawback: 'Πραγματικό μέσο διαφύλαξης αξίας',
    overline: 'Δυνατότητες',
    title: 'Δυνατότητες για τη δημιουργία πλούτου',
    subtitle: 'Σύγκριση συμβατικών τρόπων.',
    items: [
      {
        tag: 'Trading',
        name: 'Forex ή Κρύπτο',
        drawback: 'άκρως κερδοσκοπικό, απρόβλεπτο, περίπλοκο'
      },
      {
        tag: 'Μετοχές',
        name: 'Χρηματιστηριακές συναλλαγές',
        drawback: 'κίνδυνος διακυμάνσεων, απαιτούμενη γνώση, χρονοβόρο'
      },
      {
        tag: 'Κρύπτο',
        name: 'Εμπόριο',
        drawback: 'μεταβλητότητα, κίνδυνος ρύθμισης, κενά ασφαλείας'
      }
    ]
  },
  chance: {
    overline: 'Diamond',
    title: 'Η υποτιμημένη ευκαιρία',
    body: 'Τα Diamond κατατάσσονται εδώ και χρόνια μεταξύ των πιο σταθερών και υποσχόμενων μορφών επένδυσης, όμως μέχρι τώρα μόνο λίγοι αξιοποιούσαν αυτό το δυναμικό.',
    callout: 'Με το STIG ROCK ανοίγουμε για πρώτη φορά σε όλους την πρόσβαση σε αυτές τις εξαιρετικές δυνατότητες.'
  },
  wertentwicklung: {
    overline: 'Εξέλιξη αξίας 1995 — 2025',
    title: 'Μια ιστορία αξίας.',
    usd: 'Δολάριο ΗΠΑ',
    usdValue: '-49%',
    diamond: 'Diamond',
    diamondValue: '+185%',
    note: 'Εξέλιξη από το 1995 — 2025'
  },
  hauptgruende: {
    overline: 'Κύριοι λόγοι',
    title: 'Έξι λόγοι για Diamond',
    lead: 'Τα Diamond είναι πραγματικά περιουσιακά στοιχεία που υπάρχουν ανεξάρτητα από νομίσματα και χρηματοπιστωτικά συστήματα — και διατηρούν την αξία τους εδώ και αιώνες.',
    items: [
      {
        n: '01',
        title: 'Σταθερότητα αξίας σε περιόδους κρίσης',
        body: 'Εγγύηση πραγματικής αξίας. Ανεξάρτητα από νομίσματα και χρηματοπιστωτικά συστήματα.'
      },
      {
        n: '02',
        title: 'Η απόλυτη κινητικότητα',
        body: 'Μικρά, εύκολα στην απόκρυψη και τη μεταφορά.'
      },
      {
        n: '03',
        title: 'Διαφοροποίηση & Σπανιότητα',
        body: 'Στενότητα προσφοράς και φυσικός περιορισμός.'
      },
      { n: '04', title: 'Μακροπρόθεσμη ανάπτυξη', body: '+185% από το 1995.' },
      {
        n: '05',
        title: 'Διαφάνεια & Αποκλειστικότητα',
        body: 'Τα 4 Cʼs ως εγγύηση: Carat, Color, Clarity, Cut.'
      },
      {
        n: '06',
        title: 'Αποθεματικό βασιλικών οίκων',
        body: 'Ακόμα και οι βασιλικοί οίκοι χρησιμοποιούν τα Diamond ως αποθεματικό πλούτου.'
      }
    ]
  },
  markt: {
    overline: 'Όγκος αγοράς',
    title: '99 — 108 Mrd. USD',
    sub: 'Όγκος εμπορίου το έτος 2025',
    forecast: 'Πρόβλεψη έως ~2032 / 2034: περ. 140 – 168 Mrd. USD με ήπια ανάπτυξη (~4 – 5 % p.a.).',
    source: 'Πηγή: Fortune Business Insights'
  },
  innovation: {
    overline: 'Stig International — Καινοτομία',
    title: 'Μια καινοτομία. Για πρώτη φορά παγκοσμίως.',
    body: 'Το STIG ROCK είναι η πρώτη πλατφόρμα παγκοσμίως που επιτρέπει στους ανθρώπους να δημιουργήσουν παθητικό εισόδημα στην αγορά Diamond, επιπλέον της αύξησης της αξίας.',
    hq: 'STIG Gemstone FZCO DMCC — DMCC-1007195',
    hqLines: [
      'STIG Gemstone FZCO DMCC',
      'HDS Business Centre, Cluster M',
      'Jumeirah Lakes Towers — Dubai, VAE',
      'Αρ. Μητρώου DMCC-1007195'
    ],
    team: [
      { name: 'Patrick Stöger', role: 'CEO — Chief Executive Officer' },
      { name: 'Michael Lang', role: 'COO — Chief Operation Officer' }
    ]
  },
  globalNetwork: {
    overline: 'Σχετικά με την εταιρεία',
    titleLines: [ 'ΔΙΕΘΝΗΣ', 'ΔΟΜΗ', 'ΚΑΘΑΡΟ ΟΡΑΜΑ' ],
    body: 'Το STIG ROCK ιδρύθηκε για να καταστήσει την αγορά Diamond πιο διαφανή, σύγχρονη και πελατοκεντρική — με έμφαση στην εμπιστοσύνη, την ασφάλεια και τη μακροπρόθεσμη δομή.'
  },
  sicherheit: {
    overline: 'Ποιότητα & Ασφάλεια',
    title: 'Gemological Institute of America',
    body: 'Πιστοποιημένη τεχνογνωσία για τα Diamond σας. Η GIA αξιολογεί κάθε πέτρα με ύψιστη ακρίβεια και πολυετή εμπειρία — αξιόπιστες εκτιμήσεις αξίας για την εταιρεία μας και τους πελάτες μας.',
    transparency: 'Κάθε Diamond πληροί τα υψηλότερα πρότυπα ποιότητας και ελέγχεται και πιστοποιείται από αναγνωρισμένους οργανισμούς. Κάθε πέτρα είναι μοναδική και λαμβάνει ατομικό πιστοποιητικό.'
  },
  plaene: {
    overline: 'Solution Pläne (SP)',
    title: 'Μια μοναδική καινοτομία προϊόντος',
    sub: 'Έξι διαβαθμισμένα Solution Pläne — από $1K έως $100K+, το καθένα με αυξανόμενη έκπτωση ανά μήνα και για όλη τη διάρκεια.',
    recommended: 'Δημοφιλές',
    oneYear: '1 έτος',
    rowLabels: {
      delivery: 'Χρόνος παράδοσης',
      price: 'Τιμή προϊόντος',
      carat: 'Karat',
      monthly: 'Έκπτωση (Μήνας)',
      totalDiscount: 'Έκπτωση (Σύνολο)',
      duration: 'Διάρκεια'
    },
    headers: {
      plan: 'Πλάνο',
      from: 'Από',
      carat: 'Karat',
      monthly: 'Έκπτωση / Μήνα',
      total: 'Έκπτωση Σύνολο',
      duration: 'Διάρκεια'
    },
    duration: '1 έτος',
    footnote: 'Όλες οι τιμές παρέχονται χωρίς εγγύηση και εξαρτώνται από την ποιότητα, τη ζήτηση και την τρέχουσα εξέλιξη της αγοράς. Τα πλάνα Solution είναι διαθέσιμα και για 2 έτη.'
  },
  plaeneVIP: {
    overline: 'Solution Pläne + Πακέτο VIP',
    title: 'Περισσότερα οφέλη με το VIP-Paket',
    sub: 'Συνδύασε το Solution Plan σου με ένα VIP-Paket και απόλαυσε πρόσθετα πλεονεκτήματα τιμής έως και 3%. Έτσι αυξάνεις τη συνολική σου έκπτωση και εξασφαλίζεις ακόμα πιο ελκυστικούς όρους.',
    rowLabels: {
      delivery: 'Χρόνος παράδοσης',
      price: 'Τιμή προϊόντος',
      carat: 'Karat',
      monthly: 'Έκπτωση (Μήνας)',
      totalDiscount: 'Έκπτωση (Σύνολο)',
      vip1: 'Πακέτο VIP 1 (+1%)',
      vip2: 'Πακέτο VIP 2 (+2%)',
      vip3: 'Πακέτο VIP 3 (+3%)'
    },
    footnote: 'Όλες οι τιμές παρέχονται χωρίς εγγύηση και εξαρτώνται από την ποιότητα, τη ζήτηση και την τρέχουσα εξέλιξη της αγοράς.'
  },
  moeglichkeitenNach: {
    overline: 'STIG ROCK',
    title: 'Περισσότερα οφέλη με το VIP-Paket',
    sub: 'Συνδύασε το Solution Plan σου με ένα VIP-Paket και απόλαυσε πρόσθετα πλεονεκτήματα τιμής έως και 3%. Έτσι αυξάνεις τη συνολική σου έκπτωση και εξασφαλίζεις ακόμα πιο ελκυστικούς όρους.',
    options: [
      {
        key: 'deliver',
        title: 'Περισσότερα οφέλη με το VIP-Paket',
        body: 'Diamond (Karat) στην τιμή του DS-Plan* σας'
      },
      {
        key: 'sellToUs',
        title: 'Πώληση σε εμάς',
        body: 'Μπορείτε να μας μεταπωλήσετε τα Diamond σας στην τιμή αγοράς που καταβάλατε.'
      },
      {
        key: 'sellThirdParty',
        title: 'Πώληση σε τρίτους',
        body: 'Μπορείτε να μεταπωλήσετε τα Diamond σας σε τρίτους.'
      }
    ],
    footnote: '*DS-Plan σημαίνει Solution πλάνο.'
  },
  tradWeg: {
    overline: 'Παραδοσιακό εμπόριο',
    title: 'Ο παραδοσιακός δρόμος',
    sub: 'Προτού ένα Diamond φτάσει στον τελικό πελάτη, δημιουργούνται σημαντικά περιθώρια κέρδους μέσω του ενδιάμεσου, χονδρικού και λιανικού εμπορίου, σε σύγκριση με την τιμή του ακατέργαστου Diamond από το ορυχείο.',
    steps: [
      { title: 'Ορυχείο', subtitle: 'Ακατέργαστα Diamond' },
      { title: 'Ενδιάμεσος έμπορος', subtitle: 'Αγορά ακατέργαστων Diamond' },
      { title: 'Λειοτριβείο', subtitle: 'Κοπή σε Diamond κοσμημάτων' },
      { title: 'Πιστοποίηση', subtitle: 'από αναγνωρισμένα ινστιτούτα όπως η GIA' },
      { title: 'Χρηματιστήριο Diamond', subtitle: 'Πώληση σε χονδρεμπόρους' },
      { title: 'Χονδρικό εμπόριο', subtitle: 'Πώληση στο λιανικό εμπόριο' },
      { title: 'Λιανικό εμπόριο', subtitle: 'π.χ. Κοσμηματοπωλεία' },
      { title: 'Τελικός πελάτης', subtitle: 'Αγορά Diamond' }
    ]
  },
  stigWeg: {
    overline: 'STIG INTERNATIONAL GEMSTONE FZCO',
    title: 'The Dual-Purchase System',
    sub: 'One purchase. Two diamonds. Double value creation.',
    duration: '1 Purchase = 2 Diamonds = Double Value Creation',
    centerBig: '5',
    centerCaption: 'Example: $10,000 purchase = $20,000 total value',
    cycle: [
      {
        n: '1.',
        title: 'Customer Purchase',
        body: 'Customer buys a diamond with processing time, e.g. $10,000.'
      },
      {
        n: '2.',
        title: 'Dual Assignment',
        body: 'Instant and simultaneous: 1 rough diamond for the customer — 100 % their property. 1 rough diamond for the company — financed from the profit.'
      },
      {
        n: '3.',
        title: 'Value Creation',
        body: 'Combined finished sale value of both diamonds: $20,000 — in the portfolio.'
      },
      {
        n: '4.',
        title: 'Active Trading',
        body: 'The company diamond is immediately processed and traded.'
      },
      {
        n: '5.',
        title: 'Further Revenue',
        body: 'Profits flow into mining licenses, the extraction of rough diamonds and the purchase — STIG Ethical Mines.'
      }
    ],
    steps: [
      { title: 'Mine', subtitle: 'Rough diamonds' },
      { title: 'Cutting', subtitle: 'through our partners' },
      { title: 'Certification', subtitle: 'through recognised institutes' },
      { title: 'End customers', subtitle: 'Purchase & discount credits' }
    ],
    footnote: 'Rough diamond: STIG Ethical Mines · Refinement to sale: STIG International Gemstone FZCO'
  },
  vip: {
    overline: 'STIG ROCK',
    title: 'Πακέτα VIP',
    sub: 'Ισχύει για 12 μήνες για όλα τα Solution πλάνα που έχετε εγγράψει. Ανάλογα με το Πακέτο VIP: +1% έως +3% επιπλέον έκπτωση',
    cardKicker: 'επιπλέον – σε όλα τα',
    cardKicker2: 'Solution πλάνα',
    packages: [
      { name: 'VIP 1', price: '$150', bonus: '+1%' },
      { name: 'VIP 2', price: '$500', bonus: '+2%' },
      { name: 'VIP 3', price: '$1.000', bonus: '+3%' }
    ],
    example: {
      title: 'Οι εκπτώσεις γίνονται αποταμιεύσεις',
      body: 'Μηνιαία αποταμίευση αντί για μηνιαία επιβάρυνση. Από τις εκπτώσεις προκύπτουν αποταμιεύσεις – και αυτές πληρώνουν ακριβώς τα πράγματα για τα οποία διαφορετικά θα πληρώνατε κάθε μήνα από την τσέπη σας.',
      line1Label: 'DS-Plan από',
      line1Value: '$5.000',
      line2Label: 'μην. έκπτωση',
      line2Value: '3%',
      line3Label: 'Πακέτο VIP 3',
      line3Value: '+3%',
      resultLabel: 'μην. αποταμιεύσεις',
      resultValue: '$300'
    }
  },
  wertschoepfung: {
    overline: 'Πώς είναι αυτό δυνατόν;',
    title: 'Επανασχεδιάσαμε την αλυσίδα αξίας.',
    traditionalTitle: 'Ο παραδοσιακός δρόμος',
    traditionalSteps: [
      'Ορυχείο — Ακατέργαστα Diamond',
      'Ενδιάμεσος έμπορος — Αγορά',
      'Λειοτριβείο — Κοπή',
      'Πιστοποίηση (GIA)',
      'Χρηματιστήριο Diamond — Χονδρικό εμπόριο',
      'Χονδρικό εμπόριο → Λιανικό εμπόριο',
      'Κοσμηματοπωλεία → Τελικός πελάτης'
    ],
    traditionalNote: 'Προτού ένα Diamond φτάσει στον τελικό πελάτη, δημιουργούνται σημαντικά εμπορικά περιθώρια μέσω του ενδιάμεσου, χονδρικού και λιανικού εμπορίου.',
    stigTitle: 'Ο δρόμος του STIG ROCK',
    stigSteps: [
      'Άμεση αγορά — Ακατέργαστα Diamond από το ορυχείο',
      'Κοπή & Πιστοποίηση από τους συνεργάτες μας',
      'Πώληση σε τελικούς πελάτες & πελάτες B2B',
      'Έως και 4 εμπορικοί κύκλοι ανά έτος'
    ],
    stigNote: 'Σπάμε τον κύκλο και μεταφέρουμε τα εμπορικά περιθώρια ως πιστώσεις έκπτωσης στους πελάτες μας — έως και 4 εμπορικοί κύκλοι κατά τη διάρκεια του DS-Plan.'
  },
  optionen: {
    overline: 'Οι δυνατότητές σας',
    title: 'Μετά τη λήξη του Solution πλάνου σας',
    items: [
      { title: 'Παράδοση', body: 'Diamond (Karat) στην τιμή του DS-Plan σας.' },
      { title: 'Πώληση σε εμάς', body: 'Επαναγορά στην τιμή αγοράς που καταβάλατε.' },
      { title: 'Πώληση σε τρίτους', body: 'Διάθεση των Diamond στην ελεύθερη αγορά.' }
    ]
  },
  einfacherWeg: {
    overline: 'Solution πλάνα — μια μοναδική καινοτομία προϊόντος',
    title: 'Ο απλός δρόμος',
    steps: [
      {
        n: '01',
        icon: 'signup',
        title: 'Εγγραφή',
        body: 'Επικοινωνήστε με τον άτομο που σας πρότεινε και δημιουργήστε έναν δωρεάν λογαριασμό!'
      },
      { n: '02', icon: 'cart', title: 'Αγορά προϊόντος', body: 'Ήδη από $ 250,-' },
      {
        n: '03',
        icon: 'discount',
        title: 'Λήψη εκπτώσεων',
        body: 'Λάβετε μηνιαίες πιστώσεις έκπτωσης.'
      }
    ]
  },
  business: {
    overline: 'Είδη Bonus',
    title: 'Ο απλούστερος και δικαιότερος δρόμος.',
    sub: 'Πέντε είδη Bonus — για την επιτυχημένη ανάπτυξη της επιχείρησής σας.',
    bonuses: [
      {
        name: 'Unilevel Bonus',
        icon: 'unilevel',
        value: '18%',
        desc: 'Έως το Level 3, από το επίπεδο καριέρας Pearl / Ruby.'
      },
      {
        name: 'Infinity Bonus',
        icon: 'infinity',
        value: '24%',
        desc: 'Από Sapphire — σε άπειρο βάθος.'
      },
      {
        name: 'Matching Bonus',
        icon: 'matching',
        value: '5%',
        desc: 'Επί του Infinity Bonus – έως το Level 5 · ΧΩΡΙΣ προϋποθέσεις.'
      },
      {
        name: 'World Pools',
        icon: 'world',
        value: '3%',
        desc: '3 Pools από τον παγκόσμιο τζίρο.'
      },
      {
        name: 'Rang Bonus',
        icon: 'rank',
        value: '$8.325 Mio.',
        desc: 'Εφάπαξ Bonus σε Diamond (ct).'
      }
    ]
  },
  unilevel: {
    overline: 'STIG ROCK · Unilevel Bonus',
    title: 'Unilevel Bonus',
    sub: 'Αυτό το Bonus σας καταβάλλεται για κάθε νέο Solution πλάνο που εγγράφεται έως και το 3ο Level. Ξεκλειδώνετε τα επιμέρους επίπεδα με πολύ χαμηλές προϋποθέσεις.',
    total: 'Έως 18% Unilevel Bonus',
    levels: [
      {
        level: 'Level 1',
        value: '10%',
        qual: 'από την αρχή',
        coin: 'image84.png',
        badge: 'Partner'
      },
      {
        level: 'Level 2',
        value: '5%',
        qual: 'από το επίπεδο καριέρας Pearl',
        coin: 'image83.png',
        badge: 'Pearl'
      },
      {
        level: 'Level 3',
        value: '3%',
        qual: 'από το επίπεδο καριέρας Ruby',
        coin: 'image85.png',
        badge: 'Ruby'
      }
    ]
  },
  infinity: {
    overline: 'STIG ROCK · Infinity Bonus',
    title: 'Infinity Bonus',
    sub: 'Από το επίπεδο καριέρας Sapphire, πληροίτε τις προϋποθέσεις για το Infinity Bonus πλάνο μας. Λαμβάνετε 3% Bonus. Με κάθε νέο επίπεδο καριέρας προστίθενται επιπλέον ποσοστά. Εάν ένας Partner στην ομάδα σας πληροί επίσης τις προϋποθέσεις, λαμβάνετε τη διαφορά από βαθμίδα σε βαθμίδα.',
    exampleTitle: 'Παράδειγμα',
    exampleRows: [
      { label: 'Είστε Blue Diamond', value: '12%' },
      { label: 'Ο Partner σας είναι Sapphire', value: '3%' }
    ],
    exampleResult: { label: 'Το Infinity Bonus σας', value: '9%' },
    totalNote: 'Συνολικά έως 24% Infinity Bonus σε όλα τα εγγεγραμμένα Solution πλάνα στην ομάδα σας — σε άπειρο βάθος.',
    ranks: [
      { name: 'Sapphire', value: '3%', coin: 'image89.png' },
      { name: 'Emerald', value: '6%', coin: 'image90.png' },
      { name: 'Diamond', value: '9%', coin: 'image91.png' },
      { name: 'Blue Diamond', value: '12%', coin: 'image92.png' },
      { name: 'Green Diamond', value: '15%', coin: 'image93.png' },
      { name: 'Purple Diamond', value: '18%', coin: 'image94.png' },
      { name: 'Diamond Elite', value: '21%', coin: 'image96.png' },
      { name: 'Double Diamond Elite', value: '22%', coin: 'image97.png' },
      { name: 'Triple Diamond Elite', value: '23%', coin: 'image98.png' },
      { name: 'Black Diamond', value: '24%', coin: 'image99.png' }
    ]
  },
  matching: {
    overline: 'STIG ROCK · Matching Bonus',
    title: 'Matching Bonus',
    sub: 'Με αυτό το Bonus επωφελείστε από την επιτυχία της ομάδας σας. Λαμβάνετε ένα Matching Bonus 5% επί του Infinity Bonus των Partner σας — και αυτό μέχρι το 5ο επίπεδο της ομάδας σας.',
    note: 'Σε όλες τις πληρωμές Infinity Bonus στην ομάδα σας – έως το 5ο Level. Από την αρχή – ΧΩΡΙΣ προϋποθέσεις.',
    levels: [
      { level: 'Level 1', value: '5%' },
      { level: 'Level 2', value: '5%' },
      { level: 'Level 3', value: '5%' },
      { level: 'Level 4', value: '5%' },
      { level: 'Level 5', value: '5%' }
    ],
    totalPrefix: 'Συνολικά έως',
    totalValue: '25%',
    totalSuffix: 'Matching Bonus'
  },
  worldPools: {
    overline: 'STIG ROCK · Worldpools',
    title: 'Worldpools',
    sub: 'Το 3% του παγκόσμιου τζίρου εισρέει ισομερώς σε 3 διαφορετικά Pools. Με την επίτευξη συγκεκριμένων επιπέδων καριέρας, πληροίτε τις προϋποθέσεις για κάθε επιμέρους Pool.',
    forever: 'Μόλις επιτευχθεί – συμμετοχή για ΠΑΝΤΑ!',
    pools: [
      { key: 'p1', label: 'Pool 1', value: '1%', qual: 'από Blue Diamond' },
      { key: 'p2', label: 'Pool 2', value: '1%', qual: 'από Purple Diamond' },
      { key: 'p3', label: 'Pool 3', value: '1%', qual: 'από Double Diamond Elite' }
    ],
    ranks: [
      { name: 'Blue Diamond', coin: 'image92.png', shares: [ 1, 0, 0 ] },
      { name: 'Green Diamond', coin: 'image93.png', shares: [ 2, 0, 0 ] },
      { name: 'Purple Diamond', coin: 'image94.png', shares: [ 2, 1, 0 ] },
      { name: 'Diamond Elite', coin: 'image96.png', shares: [ 2, 2, 0 ] },
      { name: 'Double Diamond Elite', coin: 'image97.png', shares: [ 2, 2, 1 ] },
      { name: 'Triple Diamond Elite', coin: 'image98.png', shares: [ 2, 2, 2 ] },
      { name: 'Black Diamond', coin: 'image99.png', shares: [ 2, 2, 3 ] }
    ],
    totalPrefix: 'Συνολικά',
    totalValue: '3%',
    totalSuffix: 'του παγκόσμιου τζίρου'
  },
  rangBonus: {
    overline: 'STIG ROCK · Rang Bonus',
    title: 'Rang Bonus',
    sub: 'Από το επίπεδο καριέρας Diamond λαμβάνετε ένα Rang Bonus. Αυτό καταβάλλεται σε Diamond (Karat). Πρόκειται για ένα εφάπαξ Bonus.',
    highlight: 'Diamond (Karat) συνολικής αξίας',
    totalValue: '$8.325.000',
    ranks: [
      { name: 'Emerald', coin: 'image90.png', value: '' },
      { name: 'Diamond', coin: 'image91.png', value: '$5.000' },
      { name: 'Blue Diamond', coin: 'image92.png', value: '$20.000' },
      { name: 'Green Diamond', coin: 'image93.png', value: '$50.000' },
      { name: 'Purple Diamond', coin: 'image94.png', value: '$100.000' },
      { name: 'Diamond Elite', coin: 'image96.png', value: '$150.000' },
      { name: 'Double Diamond Elite', coin: 'image97.png', value: '$1.000.000' },
      { name: 'Triple Diamond Elite', coin: 'image98.png', value: '$2.000.000' },
      { name: 'Black Diamond', coin: 'image99.png', value: '$5.000.000' }
    ]
  },
  karriere: {
    overline: 'STIG ROCK · Επίπεδα Καριέρας',
    title: 'Επίπεδα Καριέρας',
    sub: 'Για την επίτευξη των εκάστοτε επιπέδων καριέρας προσμετράται ο ιστορικός συνολικός τζίρος (HG). Αυτός πρέπει, από το επίπεδο Sapphire και πάνω, να είναι κατανεμημένος σε περισσότερες ομάδες. Για να φτάσετε στο Ruby ή υψηλότερα, χρειάζεστε τουλάχιστον δύο άμεσους Partner με ένα Solution πλάνο.',
    forever: 'Μόλις επιτευχθεί – επιβεβαιώνεται για ΠΑΝΤΑ!',
    footnote: 'HV = Historisches Volumen (Ιστορικός Συνολικός Τζίρος).',
    ranks: [
      { name: 'Partner', coin: 'image84.png', hg: '', perks: [ '1 Unilevel' ] },
      { name: 'Pearl', coin: 'image83.png', hg: '250 HV', perks: [ '2 Unilevels' ] },
      {
        name: 'Ruby',
        coin: 'image85.png',
        hg: '500 HV',
        perks: [ '2 άμεσοι Partner', '3 Unilevels' ]
      },
      {
        name: 'Sapphire',
        coin: 'image89.png',
        hg: '25.000 HV*',
        perks: [ '3 Unilevels', 'Infinity 3%' ]
      },
      {
        name: 'Emerald',
        coin: 'image90.png',
        hg: '50.000 HV*',
        perks: [ '3 Unilevels', 'Infinity 6%' ]
      },
      {
        name: 'Diamond',
        coin: 'image91.png',
        hg: '250.000 HV*',
        perks: [ '3 Unilevels', 'Infinity 9%', '$5k Bonus' ]
      },
      {
        name: 'Blue Diamond',
        coin: 'image92.png',
        hg: '1.000.000 HV*',
        perks: [ '3 Unilevels', 'Infinity 12%', '$20k Bonus', '1 Pool' ]
      },
      {
        name: 'Green Diamond',
        coin: 'image93.png',
        hg: '2.500.000 HV*',
        perks: [ '3 Unilevels', 'Infinity 15%', '$50k Bonus', '1 Pool' ]
      },
      {
        name: 'Purple Diamond',
        coin: 'image94.png',
        hg: '5.000.000 HV*',
        perks: [ '3 Unilevels', 'Infinity 18%', '$100k Bonus', '2 Pools' ]
      },
      {
        name: 'Diamond Elite',
        coin: 'image96.png',
        hg: '10.000.000 HV*',
        perks: [ '3 Unilevels', 'Infinity 21%', '$150k Bonus', '2 Pools' ]
      },
      {
        name: 'Double Diamond Elite',
        coin: 'image97.png',
        hg: '50.000.000 HV*',
        perks: [ '3 Unilevels', 'Infinity 22%', '$1M Bonus', '3 Pools' ]
      },
      {
        name: 'Triple Diamond Elite',
        coin: 'image98.png',
        hg: '150.000.000 HV*',
        perks: [ '3 Unilevels', 'Infinity 23%', '$2M Bonus', '3 Pools' ]
      },
      {
        name: 'Black Diamond',
        coin: 'image99.png',
        hg: '500.000.000 HV*',
        perks: [ '3 Unilevels', 'Infinity 24%', '$5M Bonus', '3 Pools' ]
      }
    ]
  },
  cta: {
    overline: 'Ξεκινήστε μαζί μας',
    title: 'Η κατάλληλη στιγμή είναι τώρα.',
    body: 'Αυτό το επιχειρηματικό μοντέλο θέτει νέα πρότυπα και συνδυάζει όλους τους παράγοντες επιτυχίας για μια μακροπρόθεσμα βιώσιμη και επιτυχημένη επιχείρηση. Εγγραφείτε σήμερα, επιλέξτε το Solution πλάνο σας και αξιοποιήστε αυτή τη μοναδική επιχειρηματική ευκαιρία.',
    hint: 'Μιλήστε με το άτομο που σας κάλεσε σε αυτή την παρουσίαση — έχει έναν σύνδεσμο εγγραφής για εσάς.',
    formName: 'Όνομα',
    formEmail: 'E-Mail',
    formPhone: 'Τηλέφωνο',
    formSubmit: 'Επικοινωνήστε μαζί μας',
    success: 'Ευχαριστούμε πολύ — θα επικοινωνήσουμε μαζί σας διακριτικά και προσωπικά.',
    callCta: 'Κλήση',
    whatsapp: 'WhatsApp'
  },
  footer: {
    disclaimerTitle: 'Νομική Σημείωση & Disclaimer',
    disclaimer: 'Αυτή η παρουσίαση χρησιμεύει αποκλειστικά για ενημέρωση και δεν αποτελεί χρηματοοικονομική, επενδυτική ή φορολογική συμβουλή. Το STIG ROCK δεν είναι χρηματοοικονομικό προϊόν, αλλά αναφέρεται σε φυσικά Diamond ως περιουσιακά στοιχεία. Δεν παρέχεται καμία εγγύηση για την εξέλιξη της αξίας, τα κέρδη ή τις αποδόσεις. Οι παρελθούσες επιδόσεις δεν αποτελούν ένδειξη για μελλοντικά αποτελέσματα. Όλοι οι υπολογισμοί που παρουσιάζονται σε σχέση με τις προμήθειες είναι αποκλειστικά παραδειγματικοί και επίσης δεν αποτελούν εγγύηση. Με την επιφύλαξη αλλαγών στο περιεχόμενο — ελεύθερη μετάφραση (όχι επίσημη μετάφραση).',
    hq: 'HDS Business Centre — Jumeirah Lakes Towers — Dubai, VAE',
    copy: '© 2026 Stig International. Με την επιφύλαξη παντός δικαιώματος.',
    version: 'Έκδοση: DS-12-2025 V3'
  },
  misc: { next: 'Επόμενη ενότητα' }
};

export default el;
